var map = {
	"./airtel-grey": 147,
	"./airtel-grey.jpeg": 147,
	"./airtel-money": 148,
	"./airtel-money.png": 148,
	"./al-izza": 149,
	"./al-izza-grey": 150,
	"./al-izza-grey.png": 150,
	"./al-izza.png": 149,
	"./armoirie_and_text": 151,
	"./armoirie_and_text.png": 151,
	"./armoiries": 152,
	"./armoiries.png": 152,
	"./bg": 153,
	"./bg-results": 154,
	"./bg-results-pattern": 155,
	"./bg-results-pattern.jpg": 155,
	"./bg-results-responsive": 156,
	"./bg-results-responsive.jpg": 156,
	"./bg-results.jpg": 154,
	"./bg-title-results": 157,
	"./bg-title-results.png": 157,
	"./bg.jpeg": 153,
	"./boa-grey": 158,
	"./boa-grey.jpg": 158,
	"./check": 159,
	"./check.svg": 159,
	"./checkmark": 160,
	"./checkmark-white": 161,
	"./checkmark-white.svg": 161,
	"./checkmark.svg": 160,
	"./default-avatar": 162,
	"./default-avatar.png": 162,
	"./i-futur": 163,
	"./i-futur.png": 163,
	"./illustration": 164,
	"./illustration.svg": 164,
	"./ipay": 165,
	"./ipay.png": 165,
	"./logo-anab": 166,
	"./logo-anab.png": 166,
	"./logo-obn": 167,
	"./logo-obn.png": 167,
	"./mastercard": 168,
	"./mastercard copy": 169,
	"./mastercard copy.jpg": 169,
	"./mastercard.png": 168,
	"./moov-africa": 170,
	"./moov-africa-grey": 171,
	"./moov-africa-grey.jpeg": 171,
	"./moov-africa.jpeg": 170,
	"./niger": 172,
	"./niger.png": 172,
	"./partners/airtel": 173,
	"./partners/airtel-1": 174,
	"./partners/airtel-1.png": 174,
	"./partners/airtel.jpeg": 173,
	"./partners/amanata": 175,
	"./partners/amanata-grey": 176,
	"./partners/amanata-grey.jpeg": 176,
	"./partners/amanata.jpeg": 175,
	"./partners/ansi": 177,
	"./partners/ansi.png": 177,
	"./partners/armoiries": 178,
	"./partners/armoiries.png": 178,
	"./partners/boa": 179,
	"./partners/boa-grey": 180,
	"./partners/boa-grey.jpg": 180,
	"./partners/boa.png": 179,
	"./partners/moov-africa": 181,
	"./partners/moov-africa.jpeg": 181,
	"./partners/mtn": 182,
	"./partners/mtn.png": 182,
	"./partners/mynita": 183,
	"./partners/mynita.png": 183,
	"./partners/necs": 184,
	"./partners/necs.jpeg": 184,
	"./partners/obn": 185,
	"./partners/obn.png": 185,
	"./partners/orange": 186,
	"./partners/orange.png": 186,
	"./partners/zamani": 187,
	"./partners/zamani.jpeg": 187,
	"./regions/Agadez": 188,
	"./regions/Agadez.png": 188,
	"./regions/Diffa": 189,
	"./regions/Diffa.png": 189,
	"./regions/Dosso": 190,
	"./regions/Dosso.png": 190,
	"./regions/Maradi": 191,
	"./regions/Maradi.png": 191,
	"./regions/Niamey": 192,
	"./regions/Niamey.png": 192,
	"./regions/Tahoua": 193,
	"./regions/Tahoua.png": 193,
	"./regions/Tillaberi": 194,
	"./regions/Tillaberi.png": 194,
	"./regions/Zinder": 195,
	"./regions/Zinder.png": 195,
	"./regions/carte+du+niger": 196,
	"./regions/carte+du+niger.png": 196,
	"./regions_old/Agadez": 197,
	"./regions_old/Agadez.png": 197,
	"./regions_old/Diffa": 198,
	"./regions_old/Diffa.png": 198,
	"./regions_old/Dosso": 199,
	"./regions_old/Dosso.png": 199,
	"./regions_old/Maradi": 200,
	"./regions_old/Maradi.png": 200,
	"./regions_old/Niamey": 201,
	"./regions_old/Niamey.png": 201,
	"./regions_old/Tahoua": 202,
	"./regions_old/Tahoua.png": 202,
	"./regions_old/Tillaberi": 203,
	"./regions_old/Tillaberi.png": 203,
	"./regions_old/Zinder": 204,
	"./regions_old/Zinder.png": 204,
	"./regions_old/carte+du+niger": 205,
	"./regions_old/carte+du+niger.png": 205,
	"./trait": 206,
	"./trait.png": 206,
	"./visa": 207,
	"./visa copy": 208,
	"./visa copy.png": 208,
	"./visa.png": 207,
	"./whatsapp": 209,
	"./whatsapp.svg": 209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 222;